import { useContext, useMemo, useState } from "react";
import { Context } from "../../../context/Context";
import { Button, ListCheck } from "../../ui";
import { getCampaignText } from "./campaignActionsText";
import CampaignActionsMenu from "./CampaignActionsMenu";
import CampaignStatusOverviewModal from "./CampaignStatusOverviewModal";

// Page-level Campaign Actions on the Campaigns page: the Operations menu and
// its Activate / Cancel dialogs, always for one application per action, plus
// "Request Status" with the list of every campaign that has requests.
//   campaigns: every campaign card [{ id, app, type, title, storeId, appLabel }]
export default function CatalogCampaignActions({ campaigns, byCampaign, stores, canAct, onChanged, onViewInOperations }) {
  const { lang } = useContext(Context);
  const text = getCampaignText(lang);
  const [overview, setOverview] = useState(false);
  const storeNames = useMemo(() => Object.fromEntries(stores.map((store) => [store.id, store.storeName])), [stores]);

  return (
    <div className="ca-page-actions">
      <div className="ca-page-buttons">
        {canAct && stores.length > 0 && <CampaignActionsMenu stores={stores} onChanged={onChanged} actions={["activate", "cancel"]} />}
        <Button variant="primary" appearance="soft" size="sm" rounded icon={<ListCheck size={16} />} onClick={() => setOverview(true)}>
          {text.requestsMenu}
        </Button>
      </div>

      {overview && (
        <CampaignStatusOverviewModal
          campaigns={campaigns}
          byCampaign={byCampaign}
          storeNames={storeNames}
          canEdit={canAct}
          onClose={() => setOverview(false)}
          onChanged={onChanged}
          onViewInOperations={onViewInOperations}
        />
      )}
    </div>
  );
}
